import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-stage plan-grid py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-160" data-mp="1j9gzgtubtlbh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-161" data-mp="1n9iq87yiwubz">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-forestDeep sm:text-4xl" data-id="element-162" data-mp="1ncwq99jpsrg9">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-forest bg-white shadow-lift" data-id="element-163" data-mp="1x9rpxvrq4xw4">
          <div className="rule-gold h-2 w-full" aria-hidden="true" data-id="element-164" data-mp="226i6ek7fxvi2" />
          <div className="p-6 sm:p-10" data-id="element-165" data-mp="2v8jxj7z4c9c">
            <span className="inline-flex items-center gap-2 rounded-md border-2 border-goldDeep bg-gold px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-forestDeep" data-id="element-166" data-mp="2wa185fl1uzi">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="1mhg7uf3w6v7g" /> Main offer
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-168" data-mp="1hp6fksfb1j20">
              <div data-id="element-169" data-mp="1cosho37f3php">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-forestDeep" data-id="element-170" data-mp="17rs5rbnvzsio">
                  {productShortName}
                </h3>
                <p className="mt-2 text-sm text-inkSoft" data-id="element-171" data-mp="25er7i0tfrqnf">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-172" data-mp="1vjfrzga7efem">
                <span className="text-sm text-inkSoft" data-id="element-173" data-mp="1rgj357u2ln28">
                  Regular price <span className="line-through" data-id="element-174" data-mp="k27p4zf7h7ck">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-forest" data-id="element-175" data-mp="jzv0k3exzyqj">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-earth" data-id="element-176" data-mp="g2yuztg977gh">Today · 50% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-177" data-mp="mfjkrripyjrc">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink" data-id="element-178" data-mp="7isk7exb7205">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forestMid" aria-hidden="true" data-id="element-179" data-mp="chdiv9wwxdmh" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-180" data-mp="3i8l45t6dobd">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-inkSoft" data-id="element-181" data-mp="3pxl16p2952t4">
              <span className="inline-flex items-center gap-1.5" data-id="element-182" data-mp="3bxa95ip7hi6d">
                <LockIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-183" data-mp="3c065x3pbi0t8" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-184" data-mp="2xatmj8r2uab6">
                <ZapIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-185" data-mp="2xbd2ijx62omk" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-186" data-mp="2secyeejvnvy3">
                <ShieldCheckIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-187" data-mp="36dcntof7sevb" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-inkSoft" data-id="element-188" data-mp="3g9z7i9vt0zvr">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}